import { type PropsWithChildren } from 'react'
import { useLocation } from 'react-router-dom'
import { LoadingIndicator } from '@dhl/components'
import { useGetUserCurrentAnonymous, useGetUserCurrentAnonymousRefresh } from '@dhl/receiver-user-service-api'

export function LoggedInFilter({ children }: PropsWithChildren) {
  const location = useLocation()
  const {
    data: userData,
    isError,
    isLoading,
  } = useGetUserCurrentAnonymous({
    query: {
      refetchOnWindowFocus: false,
    },
  })

  useGetUserCurrentAnonymousRefresh()

  const isLoggedInUser = userData?.user.userType === 'consumer'

  if (isLoading) {
    return <LoadingIndicator />
  }

  if (!isError && isLoggedInUser) {
    const onboardingPrefix = '/home'
    const portalPrefix = '/portal'
    const path = location.pathname
    const search = location.search ?? ''

    if (path.startsWith(portalPrefix)) {
      // somehow we get a portal url on the app running onboarding. This should only happen during development
      // in that case throw an error so we don't land in a redirect loop.
      throw new Error(`Got invalid basePath in url: ${path}`)
    } else if (path.startsWith(onboardingPrefix)) {
      const redirectPath = path.slice(onboardingPrefix.length)
      window.location.replace(`${portalPrefix}${redirectPath}${search}`)
    } else {
      window.location.replace(`${portalPrefix}${path}${search}`)
    }
    return null
  }

  // when we're not logged (or incorrect userType), just show the children
  return children
}
